import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  ButtonGroup,
  DrawerBody,
  DrawerFooter,
  Alert
} from '@one-thd/sui-atomic-components';
import { AddToCoreContext } from '../../core/AddToCoreContext';

export const SignIn = ({ onClose }) => {
  const { addToType } = useContext(AddToCoreContext);

  const currentUrl = window.location.pathname;

  return (
    <>
      <DrawerBody>
        <Alert status="info">
          {`Please Sign In to Add to ${addToType}`}
        </Alert>
      </DrawerBody>
      <DrawerFooter>
        <ButtonGroup orientation="vertical">
          <Button
            fullWidth
            variant="primary"
            href={`/auth/view/signin?redirect=${currentUrl}`}
          >
            Sign In
          </Button>
          <Button
            fullWidth
            variant="secondary"
            onClick={onClose}
          >
            Cancel
          </Button>
        </ButtonGroup>
      </DrawerFooter>
    </>
  );
};

SignIn.propTypes = {
  onClose: PropTypes.func.isRequired
};

SignIn.displayName = 'AddToSignIn';